/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Use_Clock_TimeInputs */



/**
* | output |
* | --- |
* | "Use Clock Time" |
*
* @param {Subtitle_Export_Use_Clock_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_use_clock_time = /** @type {((inputs?: Subtitle_Export_Use_Clock_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Use_Clock_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez l'heure.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Uhrzeit verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa l'ora dell'orologio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте часовое время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar el tiempo del reloj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用时钟时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時計の時間を使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घड़ी के समय का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usar o horário do relógio")
	return /** @type {LocalizedString} */ ("Use Clock Time")
});